export default {
  locale: "fr",
  name: "Fenetre de Fermeture de Reservation",
  translation: { displayName: "Traductions" },
  fields: {
    list: [
      { fieldName: "startDate", displayName: "Date de debut" },
      { fieldName: "endDate", displayName: "Date de fin" },
      { fieldName: "weekDays", displayName: "Jours de la semaine" },
      { fieldName: "hourRange", displayName: "Plage horaire" },
      { fieldName: "timeZone", displayName: "Fuseau horaire" },
    ],
    form: [
      {
        fieldName: "restrictions",
        widget: "closeBooking",
        dateFormat: "YYYY-MM-DD",
        placeholder: "Entrez une date",
        isRange: true,
        startField: "startDate",
        endField: "endDate",
        className: "tickerInput",
      },
    ],
  },
};
